import { useEffect, useRef } from 'react';
import { Chart } from 'chart.js/auto';

// Wraps a single Chart.js instance. Rebuilt whenever `config` changes and
// destroyed on unmount. Parents should memoize `config` (useMemo).

export default function ChartCanvas({ config, height }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current || !config) return;
    chartRef.current = new Chart(canvasRef.current, config);
    return () => {
      try { chartRef.current.destroy(); } catch { /* noop */ }
      chartRef.current = null;
    };
  }, [config]);

  return (
    <div className="ss-chart" style={{ height: height || 280 }}>
      <canvas ref={canvasRef} />
    </div>
  );
}
